import { useHasAccrualLedger } from "@api/ledger.api";

/**
 * Per-entity check: does this entity have an accrual ledger?
 *
 * Thin wrapper over `useHasAccrualLedger` to give callsites that branch
 * UI on accrual vs cash ledger a clearer name. Centralizing the call also
 * leaves a single place to swap to a batched lookup later if needed.
 */
export function useIsEntityAccrual(entityId: number | undefined): boolean {
    return useHasAccrualLedger(entityId);
}
